export default __webpack_public_path__ + "static/media/free2_1.32d0e245.jpg";